import React, { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../hooks/AuthContext";
import { getBaseURL } from "../../../environment/BackendService";
import { EXTERNAL_PAGE_URI } from "../../utils/Constants";
import { ProgressSpinner } from "primereact/progressspinner";

const ExternalLookup = ({
  selectMode,
  onSelect,
  hideModal,
  params,
  readOnly = false,
  sourceData,
  onNavigate,
}) => {
  const [loading, setLoading] = useState(true);
  const { AuthHeaders } = useAuth();

  const getSource = useCallback(() => {
    const constructURL = (appName, pageName) => {
      const baseURL = getBaseURL(appName);
      const page = readOnly ? `${pageName}_READ_ONLY` : pageName;
      const URI = EXTERNAL_PAGE_URI[page];
      const {
        "session-id": sessionId,
        "auth-type": authType,
        "tenant-id": tenantId,
      } = AuthHeaders;
      return `${baseURL}${URI}?sessionId=${sessionId}&authType=${authType}&tenantId=${tenantId}`;
    };
    const { appName, pageName } = params || {};
    const url = constructURL(appName, pageName);
    return url;
  }, [params]);
  const sendDataToChild = (iframeWindow) => {
    const { fieldMapping = [] } = params;
    const selectParams = fieldMapping.default ?? {};
    let paramData = {};
    // if (readOnly) {
      paramData = selectParams.reduce((acc, item) => {
        acc[item["target"]] = sourceData[item["source"]];
        return acc;
      }, {});
    // }
    console.log("param data", paramData);
    const message = {
      type: "initData",
      data: {
        selectMode,
        data: {
          params: params.fieldMapping.default,
          selectedSchedule: [paramData],
          paramsData: paramData,
        },
      },
    };
    setTimeout(() => {
      iframeWindow.postMessage(message, "*"); // Use '*' for broad compatibility
    }, 100);
  };

  const handleIframeLoad = (event) => {
    const iframeWindow = event.target.contentWindow;
    if (iframeWindow) {
      sendDataToChild(iframeWindow);
      setLoading(false); // Hide loader after sending data
    }
  };

  const handleMessageFromChild = (event) => {
    //console.log("message back to parent");
    // You can use '*', but a better approach is to check the origin
     /*if (event.origin !== window.location.origin) {
      console.warn("Blocked message from:", event.origin);
      return;
    } */
    if (event.data.type === "hideModal") {
      hideModal(); // Update the state with response data
    }

    // Process the received message from the child
    if (event.data.type === "responseData") {
      onSelect(event.data.data); // Update the state with response data
    }
    if (event.data.type === "navigateData") {
      onNavigate({
        data: event.data.data,
        target: event.data.target,
        schedulesDataKey: event.data.schedulesDataKey,
        additionalData: event.data.additionalData,
      });
    }
  };

  useEffect(() => {
    window.addEventListener("message", handleMessageFromChild); // Add message listener

    return () => {
      window.removeEventListener("message", handleMessageFromChild); // Cleanup listener
    };
  }, []);

  return (
    <div>
      {loading && (
        <div className="card">
          <ProgressSpinner style={{ width: "50px", height: "50px" }} />
        </div>
      )}
      <iframe
        src={getSource()} // The child's URL
        style={{ width: "100%", height: "70vh" }}
        title="Child Iframe"
        onLoad={handleIframeLoad} // Handle load event directly
        name="external-lookup-iframe"
      ></iframe>
    </div>
  );
};
export default ExternalLookup;